import { useState } from "react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
interface Props {
  text: string | string[] | null;
  type?: "title" | "subtitle" | "paragraph" | "small" | "medium" | "base";
  expandable?: boolean; // if true truncates text to 200 characters and adds "show more" / "show less" buttons
  className?: string;
  expandableCharacterLength?: number;
  textColor?: string;
}

export const WTypography = ({
  className,
  expandable,
  text,
  type = "base",
  expandableCharacterLength = 200,
  textColor,
}: Props) => {
  const { t } = useTranslation("common");
  const [expanded, isExpanded] = useState(false);
  switch (type) {
    case "title":
      return (
        <h1 className={className} style={{ color: textColor }}>
          {text}
        </h1>
      );
    case "subtitle":
      return (
        <h2 className={className} style={{ color: textColor }}>
          {text}
        </h2>
      );
    case "medium":
      return (
        <h3 className={className} style={{ color: textColor }}>
          {text}
        </h3>
      );
    case "paragraph":
      return (
        <p className={className} style={{ color: textColor }}>
          {expandable &&
          !expanded &&
          text &&
          text?.length > expandableCharacterLength ? (
            <ReactMarkdown>
              {`${text?.slice(0, expandableCharacterLength) as string}
                 ...`}
            </ReactMarkdown>
          ) : (
            <ReactMarkdown>{text as string}</ReactMarkdown>
          )}
          {expandable && text && text?.length > expandableCharacterLength && (
            <button
              onClick={() => isExpanded(!expanded)}
              className="ml-2 text-ekgreen"
              type="button"
            >
              {expanded ? (
                <span>{t("show-less")}</span>
              ) : (
                <span>{t("show-more")}</span>
              )}
            </button>
          )}
        </p>
      );
    case "small":
      return (
        <p className={`text-sm ${className}`} style={{ color: textColor }}>
          {text}
        </p>
      );
    case "base":
      return (
        <div
          className={`ek-text-base ${className}`}
          style={{ color: textColor }}
        >
          {text}
        </div>
      );
  }
};

export default WTypography;
